import { Button } from "@/components/primitives/button";
import { Reply, CircleX } from "lucide-react";
import { useRtfInputState } from "@/zustand/RtfInputState";
import MarkdownRenderer from "./messages/MarkdownRenderer";
import { useNavigationState } from "@/zustand/NavigationState";
import { useTranslation } from "react-i18next";

export default function ReplyMessagePreview() {
  const { t } = useTranslation();
  const activeChatId = useNavigationState((state) => state.activeChatId);
  const parentMessage = useRtfInputState(
    (state) => state.replyMessages[activeChatId || ""],
  );
  const clearReplyMessage = useRtfInputState(
    (state) => state.clearReplyMessage,
  );

  if (!parentMessage) {
    return null;
  }

  return (
    <div className="w-full">
      <div className="flex select-none items-center gap-2 rounded-md bg-muted px-3 py-1">
        <Reply className="size-5 opacity-50" />
        <div className="flex w-full flex-col px-3 leading-5">
          <div className="text-sm text-secondary">
            Reply to {parentMessage.sender}
          </div>
          {parentMessage.content.text && (
            <MarkdownRenderer
              className="line-clamp-1 opacity-50"
              content={parentMessage.content.text}
            />
          )}
          {parentMessage.content.file && !parentMessage.content.text && (
            <div className="line-clamp-1 opacity-50">
              {parentMessage.content.file.filename}
            </div>
          )}

          {parentMessage.content.media && !parentMessage.content.text && (
            <div className="line-clamp-1 opacity-50">
              {parentMessage.content.media.fileType
                .split("/")[0]
                .charAt(0)
                .toUpperCase() +
                parentMessage.content.media.fileType.split("/")[0].slice(1)}
            </div>
          )}

          {parentMessage.content.voice && (
            <div className="line-clamp-1 opacity-50">
              {t("attachment.voice")}
            </div>
          )}
        </div>

        <Button
          size="icon"
          variant="ghost"
          onClick={() => clearReplyMessage(parentMessage.chatId)}
          className="!hover:bg-transparent size-5 shrink-0 !bg-transparent lg:cursor-pointer"
        >
          <CircleX />
        </Button>
      </div>
    </div>
  );
}
